<template>
  <v-dialog v-model="showDialog" ref="form" max-width="700" >
    <v-card
        elevation="0"
        flat
        tile
        class="pa-3"
    >
      <v-card-text class="pa-5 pb-4">
        <div class="text-center">
          <VueQrcode
              :value="getFullPublicURL()"              
              :scale="fontSize()"                           
          />
        </div>       
        <v-text-field
            outlined
            :value="getFullPublicURL()"
            :label="$t('book/facility:facility.form-sidebar.qr-code-public-path')"
            readonly
        />

      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <BaseButton
            color="primary"
            :btn-text="$t('buttons:back')"
            @clickedButton="showDialog = false"
        />
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import BaseButton from "@/modules/core/components/Base/BaseButton";
import QRCodeService from "@/modules/book/services/qrcode-service"
import VueQrcode from "vue-qrcode";

export default {
  data() {
    return {
      facilityId: String,
      showDialog: false
    }
  },
  components: {
    BaseButton,
    VueQrcode
  },
  methods: {
    getPublicURL() {
      return QRCodeService.getPublicURL();
    },
    getFullPublicURL() {
      return this.getPublicURL() + '/' + this.facilityId;
    },
    fontSize() {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': {            
            return 1;            
          }

          case 'sm': {            
            return 2;          
          }

          case 'md': {           
            return 4;          
          }

          case 'lg': {            
            return 6;            
          }

          case 'xl': {            
            return 8;             
          }       
          
          default: {            
            return 8;            
          }
      }
    }

  }
}
</script>